import React, { memo } from 'react'
import { object, string } from 'prop-types'
import { withTheme } from 'emotion-theming'

export const SearchBlock = memo(
	withTheme(
		({
			theme: {
				colors: { primary, secondary },
				SITE_NAME,
			},
			color = SITE_NAME === 'bdc' ? secondary : primary,
			stroke = '#FFFFFF',
		}) => {
			return (
				<svg
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					x="0px"
					y="0px"
					viewBox="0 0 60 60"
					style={{ enableBackground: 'new 0 0 60 60' }}
					xmlSpace="preserve"
				>
					<rect fill={color} width="60" height="60" />
					<g>
						<path
							fill="none"
							stroke={stroke}
							strokeWidth={2.1}
							strokeMiterlimit={10}
							d="M26.9,32.9c-3.5-2.8-4-7.9-1.2-11.3c2.8-3.5,7.9-4,11.3-1.2c3.5,2.8,4,7.9,1.2,11.3
				C35.4,35.2,30.3,35.7,26.9,32.9z"
						/>
						<line
							fill="none"
							stroke={stroke}
							strokeWidth={2.1}
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeMiterlimit={10}
							x1="26.7"
							y1="33.1"
							x2="20.1"
							y2="41.3"
						/>
					</g>
				</svg>
			)
		}
	)
)

SearchBlock.propTypes = {
	theme: object,
	color: string,
	stroke: string,
}
